import React from "react";
import Helmet from "react-helmet";

import defaultOgImage from "../assets/images/articulos/infantil/290-320.jpg";

const SITE_URL = "https://www.plasticoslucero.com.ar";
const SITE_NAME = "Plásticos Lucero";
const GOOGLE_SITE_VERIFICATION = "_g5cbh3Gut2PGooVMbipldaGUPl1AxieQ1mHfRd5kw0";

const organizationJsonLd = {
  "@context": "https://schema.org",
  "@type": ["Organization", "Manufacturer"],
  name: "Plásticos Lucero",
  legalName: "Plásticos Lucero SAS",
  alternateName: "Industrias Resplandor",
  url: SITE_URL,
  logo: `${SITE_URL}/icons/icon-512x512.png`,
  image: `${SITE_URL}${defaultOgImage}`,
  email: "info@plasticoslucero.com.ar",
  telephone: "+54-11-4581-6542",
  foundingDate: "1972",
  taxID: "30-71668669-4",
  description:
    "Fábrica argentina de artículos plásticos de bazar e infantil para mayoristas. Más de 50 años produciendo en CABA, con matricería e inyección propia.",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Dr. Luis Beláustegui 1158",
    addressLocality: "Caballito",
    addressRegion: "CABA",
    postalCode: "C1416CXN",
    addressCountry: "AR",
  },
  contactPoint: {
    "@type": "ContactPoint",
    contactType: "sales",
    email: "info@plasticoslucero.com.ar",
    telephone: "+54-11-4581-6542",
    areaServed: "AR",
    availableLanguage: ["es"],
  },
};

const buildAbsoluteUrl = pathOrUrl => {
  if (!pathOrUrl) return `${SITE_URL}${defaultOgImage}`;
  if (pathOrUrl.startsWith("http")) return pathOrUrl;
  return `${SITE_URL}${pathOrUrl}`;
};

const Seo = ({ title, description, image, path = "/", type = "website" }) => {
  const fullTitle = title
    ? `${title} | ${SITE_NAME}`
    : `${SITE_NAME} — Fábrica argentina de artículos plásticos de bazar e infantil para mayoristas`;
  const desc =
    description ||
    "Fábrica argentina de artículos plásticos de bazar e infantil para mayoristas. Más de 50 años produciendo en CABA con matricería e inyección propia.";
  const ogImage = buildAbsoluteUrl(image || defaultOgImage);
  const canonical = `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta name="google-site-verification" content={GOOGLE_SITE_VERIFICATION} />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={canonical} />
      <meta property="og:locale" content="es_AR" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />

      <script type="application/ld+json">{JSON.stringify(organizationJsonLd)}</script>
    </Helmet>
  );
};

export default Seo;
